module.exports = __webpack_public_path__ + "media/stairsup.56c255ac.mp4";